module.exports = __webpack_public_path__ + "img/运营发布.c5d6e8a7.png";